import script from "./EditorTagInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorTagInput.vue?vue&type=script&setup=true&lang=ts"

import "./EditorTagInput.vue?vue&type=style&index=0&id=e7656f2c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7656f2c"]])

export default __exports__